import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { styled } from '@mui/system';

const Score = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'score' && prop !== 'size',
})(({ theme, score, size }) => {
  const baseStyle = {
    width: size,
    height: size,
    fontSize: '0.75rem',
    padding: '4px',
  };

  if (score === 100) {
    return {
      ...baseStyle,
      backgroundColor: theme.palette.success.main,
      color: '#FFD700', // Bright gold
    };
  }

  if (score > 60) {
    return {
      ...baseStyle,
      backgroundColor: theme.palette.warning.main,
    };
  }

  return {
    ...baseStyle,
    backgroundColor: theme.palette.error.main,
  };
});

/**
 * How much of an item is filled in, out of 100. Hover text names what is
 * still empty, which is what the figure is for while editing.
 */
export default function CompletenessScore({
  score, missing, size, ...props
}) {
  const title = missing.length ? `Missing: ${missing.join(', ')}` : 'Complete';
  return (
    <Score score={score} size={size} title={title} {...props}>
      {score}
    </Score>
  );
}

CompletenessScore.propTypes = {
  score: PropTypes.number.isRequired,
  missing: PropTypes.arrayOf(PropTypes.string).isRequired,
  size: PropTypes.number,
};

CompletenessScore.defaultProps = {
  size: 24,
};
